// extracted by mini-css-extract-plugin
export var calculatorContainer = "cL2WTfcA";
export var formBlockContainer = "Ez8pezrX";
export var additionalBlockContainer = "_1fUlSoqB";
export var blogCalculator = "tYM2FrID";